import React, { useRef } from "react";
import GaugeChart from "react-gauge-chart";

const MyGauge = ({ value, heading, unit, maxValue = 10 }) => {
  const lastValidValueRef = useRef(0); // Store last valid value
  let numericValue = parseFloat(value);

  // Fallback to last valid value if NaN
  if (isNaN(numericValue)) {
    numericValue = lastValidValueRef.current;
  } else {
    lastValidValueRef.current = numericValue;
  }

  // Normalize value for gauge chart (based on maxValue)
  const normalizedValue = numericValue / maxValue;

  return (
    <div className="bg-gray-800 p-4 rounded-xl shadow-md text-center flex flex-col justify-center">
      <h3 className="text-lg font-bold mb-2">{heading}</h3>
      <GaugeChart
        id={`${heading.replace(/\s+/g, "-").toLowerCase()}-gauge`}
        nrOfLevels={30}
        arcWidth={0.3}
        percent={normalizedValue > 1 ? 1 : normalizedValue} // Limit to 100%
        needleColor="#fff"
        needleBaseColor="#333"
        hideText={true}
      />
      <p className="text-2xl font-bold mt-2">
        {numericValue.toFixed(1)} {unit}
      </p>
    </div>
  );
};

export default MyGauge;
